module.exports = __webpack_public_path__ + "static/web-sprite-a104dc27ee796e6ef570849361c43f42.png";